module.exports = __webpack_public_path__ + "static/0aa15c57.brazil.png";